import { useState, useEffect } from "react";
import { Input, Button, DatePicker, Table, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import request from "../../util/request";
import PointsModal from "../../components/points/pointsModal";
import "./PointsPage.css";

const initMonth = () => {
  const date = new Date();
  const month = date.getFullYear() + "/" + (date.getMonth() + 1);
  return month;
};
const PointsExpandPage = () => {
  const [month, setMonth] = useState("");
  const [number, setNumber] = useState("");
  const [points, setPoints] = useState("");
  const [expandNumber, setExpandNumber] = useState("");
  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cLoading, setCLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [detailData, setDetailData] = useState(null);
  const [mode, setMode] = useState(0);

  const onMonthInput = (date, dateString) => {
    setMonth(dateString);
  };
  const onNumberInput = (e) => {
    setNumber(e.target.value);
  };
  const onPointsInput = (e) => {
    setPoints(e.target.value);
  };
  const goCalculate = async () => {
    setMode(1);
    setCLoading(true);
    try {
      const res = await request.post(`/api/xcx-user/parent/computeReward`, {
        pageNum,
        pageSize,
        totalPoints: points,
      });
      setData(res?.list || []);
      setTotal(res?.total || 0);
    } catch (error) {
      message.error(error?.message);
    } finally {
      setCLoading(false);
    }
  };
  const goDispatch = () => {
    setTitle("发放确认");
    setIsModalOpen(true);
    setDetailData({ total: expandNumber, points, type: "expand" });
  };
  const getSearchData = async () => {
    setMode(0);
    setLoading(true);
    try {
      const res = await request.get(
        `/api/xcx-user/parent/invitesUserList?pageNum=${pageNum}&pageSize=${pageSize}`
      );
      setData(res?.list || []);
      setTotal(res?.total || 0);
    } catch (error) {
      message.error(error?.message);
    } finally {
      setLoading(false);
    }
  };

  // 获取会员总人数
  const getExpandCount = async () => {
    try {
      const res = await request.get(
        "/api/xcx-user/parent/total-promoted-users"
      );
      setExpandNumber(res);
    } catch (error) {
      message.error(error?.message);
    }
  };

  useEffect(() => {
    getExpandCount();
  }, []);
  useEffect(() => {
    if (!data.length) return;
    if (mode) goCalculate();
    else getSearchData();
  }, [pageSize, pageNum]);

  const columns = [
    {
      title: "序号",
      dataIndex: "no",
      render: (text, record, index) => index + 1,
    },
    { title: "ID号", dataIndex: "userId" },
    { title: "已邀请好友人数", dataIndex: "invitedCount" },
    {
      title: "平台邀请好友的总数=每个人邀请好友人数的总和",
      dataIndex: "totalPlatformInvites",
    },
    { title: "邀请用户所占比例", dataIndex: "inviteRatio" },
    {
      title: "本月发放积分（未分配前为0，分配后为具体数字）",
      dataIndex: "monthRewardPoints",
    },
  ];

  return (
    <div className="points-container">
      <div className="middlePart search-mod">
        <div className="points-left">
          {/* <DatePicker
            defaultValue={dayjs(month, "YYYY/MM")}
            format={"YYYY/MM"}
            onChange={onMonthInput}
            placeholder="选择月份"
            picker="month"
            style={{ width: "100px", marginRight: "4px" }}
          /> */}
          <Input
            value={number}
            disabled
            onInput={onNumberInput}
            className="input"
            placeholder="仅看推广人数大于5的用户"
          />
          <Button
            loading={loading}
            onClick={getSearchData}
            type="primary"
            icon={<SearchOutlined />}
            iconPosition="start"
            // disabled={!month}
          >
            Search
          </Button>
        </div>
        <div className="points-right">
          <span style={{ marginRight: "8px" }}>本次发放：{expandNumber}人</span>
          {/* <span>输入推广总分配积分</span> */}
          <Input
            value={points}
            onInput={onPointsInput}
            className="input"
            placeholder="输入推广总分配积分"
            style={{ width: "150px" }}
          />
          <Button
            disabled={!points}
            onClick={goCalculate}
            style={{ marginRight: "8px" }}
            type="primary"
          >
            计算
          </Button>
          <Button disabled={!points} onClick={goDispatch} type="primary">
            发放
          </Button>
        </div>
      </div>
      <div className="table">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNum,
            pageSize: pageSize,
            total,
            onChange: (pageNum, pageSize) => {
              setPageNum(pageNum);
              setPageSize(pageSize);
            },
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 条数据`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          loading={loading || cLoading}
          rowKey="userId"
        />
      </div>
      <PointsModal
        title={title}
        visible={isModalOpen}
        footer={[]}
        closeDialog={() => setIsModalOpen(false)}
        data={detailData}
      />
    </div>
  );
};

export default PointsExpandPage;
